/**
 * iRoll Variant Price Updater
 * Updates the Current Price block when variants change.
 * Works with the theme's variant picker by polling for checked option changes.
 */
(function() {
  'use strict';

  if (window.__irVariantPriceInitialized) return;
  window.__irVariantPriceInitialized = true;

  function formatPrice(cents) {
    return 'R ' + (cents / 100).toLocaleString('en-ZA');
  }

  function updatePrice(variantId) {
    if (!window.__irProductVariants) return;
    var variants = window.__irProductVariants;
    var selected = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id == variantId) {
        selected = variants[i];
        break;
      }
    }
    if (!selected) return;

    var priceEl = document.querySelector('.ir-early-roller [data-variant-price]');
    if (!priceEl) return;

    var newPrice = null;
    if (selected.metafields && selected.metafields.custom && selected.metafields.custom.xero_price_synced_variant && selected.metafields.custom.xero_price_synced_variant.value) {
      newPrice = selected.metafields.custom.xero_price_synced_variant.value;
    }
    if (!newPrice && window.__irProductMetafields && window.__irProductMetafields.custom && window.__irProductMetafields.custom.xero_price_synced_to_shopify) {
      newPrice = window.__irProductMetafields.custom.xero_price_synced_to_shopify.value;
    }
    if (!newPrice) return;

    var cents = Math.round(parseFloat(newPrice) * 100);
    if (isNaN(cents)) return;

    // Safety net (mirrors collection card): never display EFT at/above the
    // variant's card price — hide the whole block instead of showing a stale price.
    var blockEl = document.querySelector('.ir-early-roller');
    var cardCents = Math.round(parseFloat(selected.price) * 100);
    if (!isNaN(cardCents) && cardCents > 0 && cents >= cardCents) {
      if (blockEl) blockEl.style.display = 'none';
      return;
    }
    if (blockEl) blockEl.style.display = '';
    priceEl.textContent = formatPrice(cents);
  }

  // Cheapest-variant default (2026-08-19 rule): multi-variant products must
  // default to the cheaper variant. Preselect the cheapest AVAILABLE variant on
  // load — an explicit ?variant= in the URL (QR codes, collection links, admin
  // links) always wins. The picker controller then syncs URL, buy-group and EFT.
  function effectivePriceCents(v) {
    var mf = null;
    if (v.metafields && v.metafields.custom && v.metafields.custom.xero_price_synced_variant) {
      mf = v.metafields.custom.xero_price_synced_variant.value;
    }
    var raw = (mf !== null && mf !== '' && mf !== undefined) ? parseFloat(mf) : parseFloat(v.price);
    var cents = Math.round(parseFloat(raw) * 100);
    return isNaN(cents) ? Infinity : cents;
  }

  function applyCheapestDefault() {
    if (window.__irCheapestApplied) return;
    if (/[?&]variant=/.test(window.location.search)) {
      window.__irCheapestApplied = true; // explicit choice wins — nothing to do
      return;
    }
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var inputs = picker.querySelectorAll('fieldset input[data-variant-id]');
    if (inputs.length < 2) {
      window.__irCheapestApplied = true; // single-variant product — nothing to do
      return;
    }
    var variants = window.__irProductVariants || [];
    var best = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.availableForSale === false) continue;
      if (!best || effectivePriceCents(v) < effectivePriceCents(best) ||
          (effectivePriceCents(v) === effectivePriceCents(best) && v.id < best.id)) {
        best = v;
      }
    }
    if (!best) return;
    var checked = picker.querySelector('fieldset input:checked');
    if (checked && String(checked.dataset.variantId).indexOf(String(best.id)) !== -1) {
      window.__irCheapestApplied = true; // already the cheapest — done
      return;
    }
    for (var j = 0; j < inputs.length; j++) {
      if (String(inputs[j].dataset.variantId).indexOf(String(best.id)) !== -1) {
        inputs[j].click();
        window.__irCheapestApplied = true;
        lastCheckedVariantId = inputs[j].dataset.variantId; // keep the poller quiet
        updatePrice(String(best.id));
        return;
      }
    }
  }

  // Poll the variant picker for checked option changes.
  // First successful poll also applies the cheapest-variant default (the picker
  // component is upgraded and the inputs are in their initial state by then).
  var lastCheckedVariantId = null;
  var pollInterval = setInterval(function() {
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    if (!window.__irCheapestApplied) applyCheapestDefault();
    var checked = picker.querySelector('fieldset input:checked');
    if (!checked) return;
    var variantId = checked.dataset.variantId;
    if (!variantId) return;
    if (variantId === lastCheckedVariantId) return;
    lastCheckedVariantId = variantId;
    var match = String(variantId).match(/(\d+)$/);
    if (match) variantId = match[1];
    updatePrice(variantId);
  }, 200);

  // Publish-cycle marker 2026-08-19 (asset resync)
  // Also listen for theme events
  document.addEventListener('variant:update', function(e) {
    if (e.detail && e.detail.resource && e.detail.resource.id) {
      var variantId = e.detail.resource.id;
      var match = String(variantId).match(/(\d+)$/);
      if (match) variantId = match[1];
      updatePrice(variantId);
    }
  });

  // Cleanup on page unload
  window.addEventListener('beforeunload', function() {
    clearInterval(pollInterval);
  });
})();
